import { schema } from 'normalizr';

export const productTRSchema = new schema.Entity('productsTR', {}, { idAttribute: 'ProductTRId' });
export const productTRListSchema = [productTRSchema];
